import { combineReducers } from 'redux';
import { authReducers as auth } from '../modules/auth';

export const rootReducer = combineReducers({
  auth,
});
